import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { firestore } from '../../contexts/FirebaseContext';
import useAuth from '../useAuth';
import useAuthUsers from '../useAuthUsers';

const idConf = 'METHOD_PAYMENT';

function usePaymentMethodConf(arrData) {
  const [allowedMethodArr, setAllowedMethodArr] = useState([]);
  const { settingsList } = useSelector((state) => state.settingsFunc);
  const settingSelected = settingsList.find((set) => set.id === idConf);

  const { currentUser } = useAuthUsers();

  useEffect(() => {
    const activeMethods = settingSelected.methods.filter((item) => item.status === 'ACTIVE');
    const newArr = [];
    activeMethods.map((meth) => {
      const idMeth = meth.id;

      const roleFinded = meth.allowedUserRole.find((all) => all === currentUser.role);

      if (roleFinded) {
        const methodObj = arrData.find((arrMeth) => arrMeth.id === idMeth);
        newArr.push(methodObj);
      }

      setAllowedMethodArr(newArr);
      return false;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser, settingSelected]);

  return { allowedMethodArr };
}

export default usePaymentMethodConf;
